module.exports = __webpack_public_path__ + "static/media/CEPCover.34cd9d83.jpg";